import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { TosterService } from '../../services/toster.service';
import { Subject, takeUntil } from 'rxjs';
import { SelectModule } from 'primeng/select';
import { TranslationService } from '../../services/translation.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-password',
  imports: [ReactiveFormsModule, CommonModule, RouterLink,SelectModule,FormsModule,TranslateModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent implements OnDestroy {
  public translationService: TranslationService = inject(TranslationService);

  private destroy$ = new Subject<void>();
  langOptions = [
    {
      name: 'English',
      value: 'en',
      code: 'us',
    },
    {
      name: 'العربية',
      value: 'ar',
      code: 'sa',
    },
  ];
  selectedLang: string;
  forgotpassForm: FormGroup;
  constructor(private router: Router, private authService: AuthService, private tosterService: TosterService) {
    this.selectedLang = this.translationService.currentLang;

    this.forgotpassForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      // isCustomer: new FormControl(false),
    });
  }
  public onLangChange(lang: string) {
    this.translationService.changeLang(lang);
  }
  get f() {
    return this.forgotpassForm.controls;
  }


  submit() {
    if (this.forgotpassForm.invalid) return;
    // const { email, isCustomer } = this.forgotpassForm.value;
    const { email } = this.forgotpassForm.value;
    const payload = { email };
    this.authService.forgotPassword(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        if (res.status === true) {
          this.tosterService.showSuccess(res.message)
          this.router.navigate(['/otp-verification'], {
            queryParams: {
              email: this.forgotpassForm.value['email'],
              // isCustomer: !!this.forgotpassForm.value['isCustomer']
            }
          });
        }

      },
      error: (errorResponse: any) => {
        this.tosterService.showError(errorResponse.error.message)
      },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}


